import { FC } from 'react'

import { formatCountLSD } from 'utils/formatCountLSD.ts'

import s from './s.module.scss'

type Props = {
  receivedClaim: string
}

const AlreadyClaimed: FC<Props> = ({ receivedClaim }) => {
  return (
    <section className={s.claimed}>
      <span className={s.claimedDescription}>{formatCountLSD(receivedClaim)} LSD already claimed</span>
    </section>
  )
}

export default AlreadyClaimed
